import {
    Box,
    Button,
    useToast,
  } from '@chakra-ui/react';
  import { useState } from 'react';
  import DatePicker from 'react-datepicker';
  import { CalendarIcon } from '@chakra-ui/icons';
  import 'react-datepicker/dist/react-datepicker.css';
  import { Icon } from '@chakra-ui/react';

  interface DateUpdateSelectorProps {
    onSave: (date: Date) => void;
    initialDate?: Date;
  }
  
  export default function DateUpdateSelector({
    onSave,
    initialDate,
  }: DateUpdateSelectorProps) {
    const [selectedDate, setSelectedDate] = useState<Date>(initialDate || new Date());
    const toast = useToast();
  
    const handleSave = () => {
      onSave(selectedDate);
      toast({
        title: 'Date saved successfully.',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    };
  
    return (
      <>
        <Box p={2} marginY={2} borderWidth="1px" rounded="xl" shadow="md" maxW="400px">
          {/* <Stack spacing={4}> */}
          <Icon as={CalendarIcon} boxSize={5} mr={3} color="#006400" />
          <DatePicker
            selected={selectedDate}
            onChange={(date: Date | null) => {
              if (date) setSelectedDate(date);
            }}
            showTimeSelect
            dateFormat="Pp"
            className="chakra-input css-1c6xv3z"
          />
        </Box>
        <Button bg="#006400" color={'#fff'} onClick={handleSave}>
          Save Date
        </Button>
      </>
    );
  }
  
